<template>
  <fragment>
    <div
      class="gift-note--form-wrapper"
      :class="{ open: open }"
      ref="container"
    >
      <form class="gift-note--form">
        <div class="gift-note--close-container">
          <button
            class="gift-note--close"
            v-on:click.stop.prevent="toggleGiftForm"
            aria-label="close gift form"
          >
            <svg-close></svg-close>
          </button>
        </div>

        <div class="gift-note--form-label-wrapper">
          <label for="gift-note--form-input" class="gift-note--form-label">
            Write a note:
          </label>

          <button
            class="gift-note--form-clear"
            v-on:click.stop.prevent="clearNote"
            aria-label="clear form"
          >
            Clear
          </button>
        </div>

        <div class="gift-note--form-container">
          <ValidationProvider
            v-if="validateGiftNotes"
            name="gift-note"
            rules="alpha_dash_num_symbols"
            v-slot="{ errors }"
            mode="aggressive"
            slim
          >
            <textarea
              id="gift-note--form-input"
              class="gift-note--form-input"
              maxlength="150"
              placeholder="Dinner at your place?"
              name="gift-note"
              v-model="note"
            ></textarea>

            <p v-if="errors && errors.length" class="gift-note--form-error">
              {{ errors && errors[0] }}
            </p>
          </ValidationProvider>
          <textarea
            v-else
            id="gift-note--form-input"
            class="gift-note--form-input"
            maxlength="150"
            placeholder="Dinner at your place?"
            name="gift-note"
            v-model="note"
          ></textarea>

          <div v-show="notePresent" class="gift-note--form-counter">
            You have {{ remainingChars }} characters remaining.
          </div>
        </div>

        <button
          type="button"
          class="button__main"
          style="display: flex-inline; width: auto"
          @click="toggleGiftForm"
        >
          ADD TO ORDER
        </button>

        <div class="gift-note--form-disclaimer">
          {{ noteDisclaimer }}
        </div>
      </form>
    </div>
  </fragment>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createFocusTrap } from "focus-trap";
import { checkCanFocusTrap } from "@/lib/focus-trap-utils";

export default {
  name: "cart-gift-note",
  data() {
    return {
      noteDisclaimer: window.theme.cartConfig.giftNoteDisclaimer || "",
      trap: null,
      validateGiftNotes: window.theme.cartConfig.validateGiftNotes || false,
    };
  },
  computed: {
    note: {
      get: mapState({ note: (state) => state.cart.data.note }).note,
      set(value) {
        this.$store.dispatch(`cart/updateNote`, value);
      },
    },
    ...mapState({
      open: (state) => state.cart.giftFormOpen,
    }),
    notePresent() {
      return this.note?.length;
    },
    remainingChars() {
      return 150 - this.note?.length;
    },
  },
  watch: {
    open(giftFormOpen) {
      if (giftFormOpen) {
        this.trap.activate();
      } else {
        this.trap.deactivate();
      }
    },
  },
  methods: {
    ...mapActions({
      clearNote: "cart/clearNote",
      toggleGiftForm: "cart/toggleGiftForm",
    }),
    checkTransitionProperty(trapContainer) {
      const opacity = getComputedStyle(trapContainer).opacity;
      return opacity === "1";
    },
  },
  mounted() {
    this.trap = createFocusTrap(this.$refs.container, {
      escapeDeactivates: (e) => this.toggleGiftForm(),
      checkCanFocusTrap: (trapContainers) =>
        checkCanFocusTrap(trapContainers, this.checkTransitionProperty),
      clickOutsideDeactivates: true,
    });
  },
};
</script>
